import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import BodyWrap from "../utils/BodyWrap";
import ContentDiv from "../utils/ContentDiv";
import GeneralLoader from "../GeneralLoader";
import SectionFooter from "../utils/SectionFooter";
import ReviewSearch from "./review-search/ReviewSearch";
import SectionBanner from "../utils/SectionBanner";
import ReviewPreview from "./ReviewPreview";

// CSS
import "../../css/reviews/review-page.css";
import "../../css/reviews/reviews-search.css";

// State
import { getTranslations } from "../../store/actions/translations";
import { getSignedUpReviews, getPastReviews } from "../../store/actions/reviews";
import { getReviewerReviews } from "../../store/actions/user";

class RelatedReviews extends Component {
	static initialAction(store, props, translationKey = null) {
		const promises = [];
		const translationSections = ["reviews", "buttons", "review_registration_dialog"];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		let resTranslations =
			store !== null
				? getTranslations([translationKey], translationSections, translationKey)
				: props.getTranslations([translationKey], translationSections, translationKey);
		promises.push(resTranslations);

		return promises;
	}

	static userActions(store, props) {
		const promises = [];

		if (store !== null) {
			promises.push(getPastReviews(4));
			promises.push(getSignedUpReviews(4));
			promises.push(getReviewerReviews());
		} else {
			promises.push(props.getPastReviews(4));
			promises.push(props.getSignedUpReviews(4));
			promises.push(props.getReviewerReviews());
		}

		return promises;
	}

	componentWillMount() {
		RelatedReviews.userActions(null, this.props);
	}

	componentDidMount() {
		if (!this.props.translations.pages[this.props.translationKey]) {
			RelatedReviews.initialAction(null, this.props);
		}
	}

	render() {
		const {
			translationsLoading,
			translations,
			pastReviewsIsLoading,
			pastReviews,
			userReviewsLoading,
			signedUpReviews,
			signedUpReviewsIsLoading,
			search
		} = this.props;

		return (
			<BodyWrap>
				<main>
					<div className="page-content">
						<div className="section-row">
							<div className="section section-2--main">
								{translationsLoading ? (
									<GeneralLoader />
								) : !!translations.pages[this.props.translationKey] ? (
									<ContentDiv>
										{translations.pages[this.props.translationKey].content}
									</ContentDiv>
								) : null}
							</div>
							{!translationsLoading && (
								<div className="section section-2--side">
									<SectionFooter href="/reviews">
										{translations.sections.reviews.view_all_reviews_link}
									</SectionFooter>
									<ReviewSearch types={["related", "past"]} />
								</div>
							)}
						</div>
						{!translationsLoading && (
							<React.Fragment>
								<div className="section-row section-row--block">
									<div className="section-content pt0 pb0">
										<SectionBanner>
											{translations.sections.reviews.my_reviews_title}
										</SectionBanner>

										{signedUpReviewsIsLoading || search.inProgress ? (
											<GeneralLoader />
										) : (
												<div className="preview-area pt1">
													{signedUpReviews.length ? (
														signedUpReviews.map((review, i) => (
															<ReviewPreview key={i} review={review} signedUp/>
														))
													) : (
															<div>
																{
																	translations.sections.reviews
																		.no_reviews_search_response
																}
															</div>
														)}
												</div>
											)}
									</div>
								</div>
								<div className="section-row section-row--block">
									<div className="section-content pt0 pb0">
										<SectionBanner
											link={{
												href: `/reviews/past`,
												title:
													translations.sections.reviews.past_reviews_link
											}}
										>
											{translations.sections.reviews.past_reviews_title}
										</SectionBanner>

										{pastReviewsIsLoading ||
											userReviewsLoading ||
											search.inProgress ? (
												<GeneralLoader />
											) : (
												<div className="preview-area pt1">
													{pastReviews.length ? (
														pastReviews.map((review, i) => (
															<ReviewPreview key={i} review={review} />
														))
													) : (
															<div>
																{
																	translations.sections.reviews
																		.no_past_reviews_response
																}
															</div>
														)}
												</div>
											)}
									</div>
								</div>
							</React.Fragment>
						)}
					</div>
				</main>
			</BodyWrap>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations,
		pastReviewsIsLoading:
			state.reviews.pastIsLoading !== undefined ? state.reviews.pastIsLoading : 1,
		pastReviews: state.reviews.pastReviews,
		userReviewsLoading:
			state.user.reviewerReviewsLoading !== undefined ? state.user.reviewerReviewsLoading : 1,
		signedUpReviewsIsLoading:
			state.reviews.signedUpReviewsIsLoading !== undefined ? state.reviews.signedUpReviewsIsLoading : 1,
		signedUpReviews: state.reviews.signedUpReviews,
		search: state.reviewSearch
	};
};

export default connect(
	mapStateToProps,
	{ getTranslations, getSignedUpReviews, getPastReviews, getReviewerReviews }
)(RelatedReviews);



// WEBPACK FOOTER //
// ./src/components/reviews/RelatedReviews.js